<mat-card>
    <div class="d-flex justify-content-between w-100" >
        <div class="container1">
            <div class="header">
                <h6>{{asset.assetName ? (asset.assetName | translate) : ''}}</h6>
            </div>
            <div class="details w-100">
              <div class="detail">
                    <span class="key">{{'livlihoodCategories' | translate}}:</span>
                    <span class="value">
                        {{asset.livelihoodCategory ? getLabelByValue(asset.livelihoodCategory) : 'NA'}}
                    </span>
                </div>
               <div class="detail">
                    <span class="key">{{'livelihoodActivity' | translate}}:</span>
                    <span class="value">
                        {{asset.livelihoodActivity ? (asset.livelihoodActivity | normalizeString | translate) : 'NA'}}
                    </span>
                </div>
                <div class="detail">
                    <span class="key">{{'statusOfAsset' | translate}}:</span>
                    <span class="value">
                        {{asset.statusOfAsset ? (asset.statusOfAsset | translate) : 'NA'}}
                    </span>
                </div>
                   <div class="detail">
                    <span class="key">{{'assetType' | translate}}:</span>
                    <span class="value">{{asset.assetType && asset.assetType !== 'notApplicable'  ? (asset.assetType | translate) : 'NA'}}</span>
                </div>
                <div class="detail">
                    <span class="key">{{'ProcurementSource' | translate}}:</span>
                    <span class="value">{{asset.procurementSource ? (asset.procurementSource | translate) : 'NA'}}</span>
                </div>
                <div class="detail">
                    <span class="key">{{'estimatedCost' | translate}}:</span>
                    <span class="value">{{asset.estimatedCost ? (asset.estimatedCost | indianFormat) : 'NA'}}</span>
                </div>

                <div class="action-detail">
                  <button type="button" (click)="edit()">
                        @if (!readOnly) {
                            <img class="menu-icons" src="https://cdn.lokos.in/aajeevika/assets/img/edit.svg" alt="">
                            <span class="menu-labels">{{'edit' | translate}}</span>
                        } @else {
                            <img class="menu-icons" src="../../../../assets/images/eyeIcon.svg" alt="">
                            <span class="menu-labels">{{'view' | translate}}</span>
                        }
                    </button>
                    @if (!readOnly) {
                        <button type="button" (click)="delete()" [ngClass]="{'disabled': readOnly}">
                            <img class="menu-icons" src="https://cdn.lokos.in/aajeevika/assets/img/delete.svg" alt="">
                            <span class="menu-labels">{{'delete' | translate}}</span>
                        </button>
                    }
                </div>
            </div>
        </div>

    </div>
</mat-card>
